import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Texas House Cleaning | Professional Residential Cleaning Services",
  description = "Professional residential cleaning services in Texas. Expert standard cleaning, deep cleaning, and move-out cleaning. Call (346) 203-1728 for a free quote. Trusted, insured, and eco-friendly.",
  keywords = "house cleaning Texas, residential cleaning, deep cleaning, move-out cleaning, professional cleaning services, eco-friendly cleaning, standard cleaning, Texas cleaning service",
  ogImage = "https://customer-assets.emergentagent.com/job_house-cleaning-quote-1/artifacts/oimdgj31_texas_logo.png"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Texas House Cleaning" />
      <link rel="canonical" href="https://house-cleaning-quote-1.preview.emergentagent.com" />
    </Helmet>
  );
};

export default SEO;
